import {FIMLAB} from "../../../data/reducer";

const createActionName = require('../../../data/util').createActionName('timelineframe')

export const NAVIGATE_TO_TIMELINEFRAME = createActionName("NAVIGATE_TO_TIMELINEFRAME");
export const CLEAR_NAVIGATE_TO_TIMELINEFRAME = createActionName("CLEAR_NAVIGATE_TO_TIMELINEFRAME");
export const RECEIVE_GENERIC_PHRASES = createActionName("RECEIVE_GENERIC_PHRASES");
export const REQUEST_GENERIC_PHRASES_FAILED = createActionName("REQUEST_GENERIC_PHRASES_FAILED");

export const navigateToTimelineFrame = (timelineEventId) => ({
    type: NAVIGATE_TO_TIMELINEFRAME,
    data: timelineEventId
})

export const receiveGenericPhrases = (phrases) => ({
    type: RECEIVE_GENERIC_PHRASES,
    data: phrases
})

export const requestGenericPhrasesFailed = (err) => ({
    type: REQUEST_GENERIC_PHRASES_FAILED,
    data: err
})

export const navigateToTimelineFrameFimlab = (groupId) => (dispatch, getState) => {
    let labEvents = getState()[FIMLAB].data;

    const foundMatchingLabEvent = labEvents.filter(l => l.groupId === groupId);

    if (foundMatchingLabEvent && foundMatchingLabEvent.length === 1) {
        dispatch(navigateToTimelineFrame(foundMatchingLabEvent[0].id));
    }
}

export const doGetGenericPhrases = () => (dispatch, getState, services) => {
    services.api
        .getGenericPhrases()
        .then((data) => {
            dispatch(receiveGenericPhrases(data));
        })
        .catch((err) => {
            dispatch(requestGenericPhrasesFailed(err));
        });
}

export const clearNavigateToTimelineFrame = () => ({
    type: CLEAR_NAVIGATE_TO_TIMELINEFRAME
})